var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _circle, _path9;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNavSchools = function SvgIconNavSchools(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 103.595,
    viewBox: "0 0 90.885 103.595",
    width: 90.885,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.514 46.159h2.691v44.587h-2.691z",
    fill: "#47a7c4",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.641v26.707h-7.641z",
    fill: "#47a7c4",
    opacity: 0.2,
    transform: "matrix(0 -1 1 0 7.497 54.968)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.982 46.913h60.143v44.792h-60.143z",
    fill: "#fff",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1485.22 93.822h-36.075l-13.964 18.619h64z",
    fill: "#11526a",
    transform: "translate(-1435.181 -65.528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m52.367 18.843v-17.843",
    fill: "#fff",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1536.6 60.17-9.31 4.655v-9.31z",
    fill: "#11526a",
    transform: "translate(-1468.716 -49.861)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m1526.507 57.173-7.758 2.327v-10.085l7.758 2.327z",
    fill: "#11526a",
    transform: "translate(-1465.607 -47.64)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1525.431 88.754-18.231-14.454-18.231 14.452v60.931h36.462z",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.017,
    transform: "translate(-1454.764 -58.422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1523.868 172.346v-31.261h-20.268v31.261",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    transform: "translate(-1460.09 -82.736)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.56,
    cy: 37.441,
    r: 9.207,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1513.564 102.437 2.327 3.1 3.1-4.655",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    transform: "translate(-1463.719 -68.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1514.848 127.54c0 16.987 18.65 35.339 18.65 35.339s18.651-19 18.651-35.339c0-9.554-8.35-17.3-18.651-17.3s-18.65 7.745-18.65 17.3z",
    transform: "translate(-1461.264 -59.284)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.234,
    cy: 69.239,
    r: 8.013
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "themed-fill",
    d: "m1520.092 129.535c0 14.462 15.877 30.085 15.877 30.085s15.878-16.175 15.878-30.085c0-8.134-7.109-14.728-15.878-14.728s-15.877 6.593-15.877 14.728z",
    fill: "#3393b9",
    transform: "translate(-1463.736 -61.436)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.234,
    cy: 68.937,
    fill: "#fff",
    r: 6.822
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m15.05 60.303h12.192v12.192h-12.192z",
    fill: "#fff",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNavSchools, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-nav-schools.4db58490.svg";
export { ForwardRef as ReactComponent };